import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.auth.error,
    props.auth.buttons.auth,
    props.auth.buttons.guest,
    props.user.isAuth,
    (error, auth, guest, isAuth) => {
        return {
            isAuth,
            error,
            buttons: {
                auth,
                guest
            }
        }
    }
)